<template>
  <transition name="fade">
    <div class="tips-dialog" v-if="showTipsDialog">
      <div class="mask"></div>
      <div class="content">
        <img
          src="@/assets/ic-close-white.png"
          alt=""
          class="close-btn"
          @click="handleClose"
        />
        <div class="title">
          <img src="@/assets/ic-light-yellow.png" alt="" />
          你可以这样说:
        </div>
        <div class="text">{{ promptContent }}</div>
      </div>
    </div>
  </transition>
</template>

<script setup>
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { ref, computed, watch } from "vue";
import { getHistoryById } from "@/api/deepseek.js";
import { getChatHistoryPage } from "@/api/aiTeacher.js";

const props = defineProps({
  showTipsDialog: {
    type: Boolean,
    default: false,
  },
  promptContent: {
    type: String,
    default: "I really like English",
  },
});

const emit = defineEmits([]);

const handleClose = () => {
  emit("close");
};

// 暴露方法给父组件
defineExpose({});
</script>

<style scoped lang="scss">
// 淡入淡出过渡效果
.fade-enter-active {
  transition: opacity 0.3s ease;
  
  .content {
    animation: slideUp 0.3s ease;
  }
}

.fade-leave-active {
  transition: opacity 0.25s ease;
  
  .content {
    animation: slideDown 0.25s ease;
  }
}

.fade-enter-from {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

// 内容区域动画：从下往上滑入
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

// 内容区域动画：向下滑出
@keyframes slideDown {
  from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  to {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
}

.tips-dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  pointer-events: none;

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.5);
    pointer-events: auto;
  }

  .content {
    position: absolute;
    top: 398px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 300px;
    min-height: 67px;
    background: #000000;
    border-radius: 20px;
    padding: 10px 13px;
    box-sizing: border-box;
    pointer-events: auto;
    z-index: 1;

    .close-btn {
      position: absolute;
      top: 8px;
      right: 10px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      pointer-events: auto;
    }

    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #dddddd;
      img {
        width: 12px;
        height: 16px;
        margin-right: 5px;
      }
    }

    .text {
      margin-top: 6px;
      font-size: 15px;
      color: #ffffff;
    }
  }
}
</style>
